namespace AgerLMS.LMS {
    export namespace LocalService {
        export const baseUrl = 'WebSite/Local';


        export declare const enum Methods {

        }

    }
}
